import { render } from "./MessagesPreview.vue?vue&type=template&id=5096c2df&ts=true"
import script from "./MessagesPreview.ts?vue&type=script&lang=ts&external"
export * from "./MessagesPreview.ts?vue&type=script&lang=ts&external"

import "./MessagesPreview.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__